import React from 'react';
import _ from 'lodash';

import { AudioPlayer } from 'components';
import AudioContainer from '../AudioContainer';

export default ( { values, onSaveFavourite } ) => {
  const refAudio1 = React.createRef();
  const refAudio2 = React.createRef();
  const refAudio3 = React.createRef();

  return (
    <>
      {values.introductionFile
      && (
        <AudioContainer onSaveFavourite={() => onSaveFavourite( 'introductionFile' )} id="aud-1">
          <AudioPlayer
            src={values.introductionFile.uri}
            ref={refAudio1}
            onPlay={() => {
              if ( _.get( refAudio2.current, 'context.media' ) ) refAudio2.current.context.media.pause();
              if ( _.get( refAudio3.current, 'context.media' ) ) refAudio3.current.context.media.pause();
            }}
          />
        </AudioContainer>
      )}

      {values.optionsFile
      && (
        <AudioContainer onSaveFavourite={() => onSaveFavourite( 'optionsFile' )} id="aud-2">
          <AudioPlayer
            src={values.optionsFile.uri}
            ref={refAudio2}
            onPlay={() => {
              if ( _.get( refAudio1.current, 'context.media' ) ) refAudio1.current.context.media.pause();
              if ( _.get( refAudio3.current, 'context.media' ) ) refAudio3.current.context.media.pause();
            }}
          />
        </AudioContainer>
      )}

      {values.farewellFile
      && (
        <AudioContainer onSaveFavourite={() => onSaveFavourite( 'farewellFile' )} id="aud-3">
          <AudioPlayer
            src={values.farewellFile.uri}
            ref={refAudio3}
            onPlay={() => {
              if ( _.get( refAudio1.current, 'context.media' ) ) refAudio1.current.context.media.pause();
              if ( _.get( refAudio2.current, 'context.media' ) ) refAudio2.current.context.media.pause();
            }}
          />
        </AudioContainer>
      )}
    </>
  );
};
